import React, { useEffect, useState } from 'react';
import DetailPageTitleComponent from '../../../components/NewDesign/Misc/DetailPageTitle/DetailPageTitleComponent';
import DetailPageDescComponent from '../../../components/NewDesign/Misc/DetailPageDesc/DetailPageDescComponent';
import './ArticleComp.scss';
import SessionRequest from '../home/SessionRequest';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { Col, Row } from 'react-bootstrap';

const ArticleComp = ({ title, content, banner, tagsArray, isLoading, setLoadFalse }) => {
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [coachUrl, setCoachUrl] = useState("");
  useEffect(() => {
    setLoadFalse();
  }, [])

  useEffect(() => {
    let userDetailResLocal = userDetailRes;
    console.log("userDetailResLocal", userDetailResLocal);
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal?.status === "success") {
        let journey = userDetailResLocal?.payload?.payload?.money_journey;
        setCoachUrl(journey?.coach);

      }
    }
  }, [userDetailRes]);
  return (
    <div class="action-sec action-sec-inner">
       <Row>
        <Col md={8}>
          <div class=" banner-box">
            <div class="img-box-banner">
              <img src={banner ? banner : "/images/finwell-img/action-banner.png"} alt="" class="img-fluid" />
            </div>
        <ul>
          <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.58197 8.25H8.83197V9H3.58197V8.25Z" fill="#415385" />
            <path d="M8.83197 6H3.58197V6.75H8.83197V6Z" fill="#415385" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1.33197 0H7.62861L10.668 3.38043V12H1.33197V0ZM9.6216 3.30652L7.72846 0.995845V3.30652H9.6216ZM9.96651 3.82389V11.2985H2.03347V0.7015H7.02696V3.82389H9.96651Z"
              fill="#415385" />
            <path
              d="M7.63197 0L10.668 3.384L10.668 12H1.33197V0H7.63197ZM7.03197 0.696H2.03997V11.304H9.97197V3.828H7.03197V0.696ZM8.83197 8.244L8.83197 9H3.58797V8.244H8.83197ZM8.83197 6L8.83197 6.744H3.58797V6H8.83197ZM7.72797 0.996V3.3H9.62397L7.72797 0.996Z"
              fill="#415385" />
          </svg> {tagsArray[0]}</li>
          <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3626_44634)">
              <path
                d="M11.295 2.52H3.01333L2.32667 1.85833H10.5733V1.11833L1.58667 1.15833L1 0.61H9.725V0.005L0.345001 0V9.905L2.58833 12H11.295C11.4933 12 11.655 11.835 11.655 11.6333V2.88667C11.655 2.68333 11.4933 2.52 11.295 2.52ZM2.49833 10.905L1.08833 9.64167L1.13167 1.73167L2.54167 3.05833L2.49833 10.905ZM5.09667 3.25833H8.24667V7.37333L6.67167 6.345L5.09667 7.37333V3.25833ZM3.24 11.26V3.25833H4.35334V8.74833L6.67167 7.23333L8.99 8.74833V3.25833H10.9367V11.26H3.24Z"
                fill="#415385" />
            </g>
            <defs>
              <clipPath id="clip0_3626_44634">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg> {tagsArray[1]}</li>
          <li dangerouslySetInnerHTML={{
                    __html: tagsArray[2]
                }}></li>
          <li dangerouslySetInnerHTML={{
                    __html: tagsArray[3]
                }}></li>
        </ul>
       {false && <DetailPageTitleComponent
          title={title}
          isLoading={isLoading}
        /> }
        <DetailPageDescComponent
          desc={content}
          isLoading={isLoading}
        />
      </div>
        </Col>

        <Col md={4}>        
        <SessionRequest from="right" coach={coachUrl} />     
        </Col>
      </Row>
      
    </div>

  
  );
};

export default ArticleComp;